import Flex from "@/components/flex"
import { langStore } from "@/stores/lang-store"
import { leakChartStore } from "./leak-chart-store"
import DateFilterButton from "@/components/buttons/date-filter-button"
import { calcStartDate } from "@/utils/calc-start-date-util"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { useParams } from "react-router-dom"
import { periodStore } from "@/components/detail-modal/period-store"
import DateInput from "@/components/date-input"
import { leakChartBundle } from "./leak-chart-const"

const ChartToolbar = () => {
  const { apt } = useParams()

  const { lang } = langStore()
  const { ended_at: end_date } = aptSearchStore((s) => s.pickApt)

  const { pickUnit, startLabel, endLabel, apiGetLeakChart, selectedPeriod, setSelectedPeriod } =
    leakChartStore()

  const { startDate, endDate, setStartDate, setEndDate } = periodStore()

  const dateFilter = (preset) => {
    let start_date = calcStartDate(end_date, preset)

    if (preset === "leakStartTime") {
      start_date = pickUnit.leakStartAt.slice(0, 10)
    }
    setEndDate(end_date)
    setStartDate(start_date)

    setSelectedPeriod(preset)

    apiGetLeakChart({
      apt,
      dong: pickUnit.dong,
      ho: pickUnit.ho,
      start_date,
      end_date
    })
  }

  return (
    <div className="px-2">
      {/* top */}
      <Flex className="items-end justify-between mb-3">
        <div>
          <h3 className="text-lg font-semibold text-[#1f2937]">{leakChartBundle.title[lang]}</h3>

          {startLabel !== "-" && endLabel !== "-" ? (
            <p className="mt-0.5 text-sm text-gray-400">
              {startLabel.replace(/-/g, ".")}
              {leakChartBundle.time[lang]}
              {" ~ "}
              {endLabel.replace(/-/g, ".")}
              {leakChartBundle.time[lang]}
            </p>
          ) : (
            <p className="mt-0.5 text-sm text-gray-400">
              {leakChartBundle.noSelectionMessage[lang]}
            </p>
          )}
        </div>
      </Flex>

      <Flex
        className="
      items-center justify-between
      rounded-xl
      border border-[#edf0f3]
      bg-white
      px-3 py-2
      shadow-[0_1px_2px_rgba(15,23,42,0.04)]
    "
      >
        <Flex className="items-center" gap={6}>
          {leakChartBundle.dateFilters.map((item) => {
            const { key, label } = item

            return (
              <DateFilterButton
                key={key}
                isActive={selectedPeriod === key}
                onClick={() => dateFilter(key)}
                disabled={!pickUnit}
              >
                {label[lang]}
              </DateFilterButton>
            )
          })}

          <div className="w-px h-5 bg-[#e8ecf1] mx-1" />

          <DateFilterButton
            isActive={selectedPeriod === leakChartBundle.leakStartTimeFilter.key}
            onClick={() => dateFilter(leakChartBundle.leakStartTimeFilter.key)}
            disabled={!pickUnit}
          >
            {leakChartBundle.leakStartTimeFilter.label[lang]}
          </DateFilterButton>
        </Flex>

        <Flex className="items-center" gap={8}>
          <span className="text-sm text-gray-400">{leakChartBundle.customRangeLabel[lang]}</span>

          <DateInput
            value={startDate}
            onChange={(e) => {
              setSelectedPeriod(null)
              setStartDate(e.target.value)
            }}
          />

          <span className="text-sm text-gray-300">~</span>

          <DateInput
            value={endDate}
            onChange={(e) => {
              setSelectedPeriod(null)
              setEndDate(e.target.value)
            }}
          />

          <button
            onClick={async () =>
              await apiGetLeakChart({
                dong: pickUnit.dong,
                ho: pickUnit.ho,
                start_date: startDate,
                end_date: endDate
              })
            }
            className="
          h-8
          rounded-lg
          bg-[#022047]
          px-3.5
          text-sm
          font-medium
          text-white
          transition-colors
          hover:bg-[#03306a]
        "
          >
            {leakChartBundle.search[lang]}
          </button>
        </Flex>
      </Flex>
    </div>
  )
}

export default ChartToolbar
